import { HomeAutomationIcon } from './HomeAutomationIcon';

/**
 * author: GreenTurtwig
 * id FD2567BF-09EC-4871-B3E8-DAE9CDCF3A38
 * name home-automation
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-automation.svg
 * tags
 * - Home Automation 
 */
export const SmartHouseIcon = HomeAutomationIcon;
export default SmartHouseIcon